import React, { PureComponent } from 'react';
import styled, { css } from 'react-emotion';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import StepTitle from '../../../../common/StepTitle';
import { EventSteps } from '../../shared/EventSteps/EventSteps';
import Button from '../../../../common/Button';
import { Link } from 'react-router-dom';
import { DEFAULT_FLOW } from '../../ContractCreatePage';

const Container = styled('div')`
  display: flex;
  height: 500px;
  flex-direction: column;
  align-items: center;
`;

const EventStepsTitle = styled('h3')`
  margin-top: 0;
  margin-bottom: 40px;
`;

const buttonsStyle = css({
  float: 'right'
});

const duplicateButtonStyle = css({
  marginRight: '15px'
});

class ResultStep extends PureComponent {
  static propTypes = {
    contract: PropTypes.object
  };

  backToStartAndPersistFlow = () => {
    const { parentWizard, onChange } = this.props;
    onChange({ createSuccessful: false }, () => parentWizard.setStep('start'));
  };

  backToStartAndResetFlow = () => {
    const { parentWizard, onChange } = this.props;
    onChange(DEFAULT_FLOW, () => parentWizard.setStep('start'));
  };

  render() {
    const {
      t,
      flow: { acceptors, createdTerms }
    } = this.props;

    const steps = [
      t('createContract:result.step_0'),
      t('createContract:result.step_1', { count: acceptors.length }),
      t('createContract:result.step_2', { count: acceptors.length })
    ];

    const successRender = (
      <Container>
        <StepTitle
          icon="finalize-contract-l"
          title={t('createContract:result.header')}
          description={t('createContract:result.description', { count: acceptors.length })}
          titleStyle="success"
        />
        <div>
          <EventStepsTitle>{t('createContract:result.whatHappensNext')}</EventStepsTitle>
          <EventSteps steps={steps} activeIndex={0} />
        </div>
      </Container>
    );

    const contract = createdTerms[0];

    const createNewContractButton = (
      <Button className="btn btn-primary" onClick={this.backToStartAndResetFlow}>
        {t('createContract:result.createNewContract', { count: acceptors.length })}
      </Button>
    );

    const viewContractButton = (
      <Link className="btn btn-primary" to={`/${contract.termId}/${contract.revisionId}`}>
        {t('createContract:result.viewContract')}
      </Link>
    );

    const secondaryButton = createdTerms.length === 1 ? viewContractButton : createNewContractButton;

    const steppers = (
      <div className="row">
        <div className="col-sm-12 col-md-3">
          <Link className="btn btn-default btn-block" to="/">
            {t('createContract:result.backToHomePage')}
          </Link>
        </div>
        <div className="col-md-2" />
        <div className="col-sm-12 col-md-7">
          <div className={buttonsStyle}>
            <span className={duplicateButtonStyle}>
              <Button className="btn btn-default" onClick={this.backToStartAndPersistFlow}>
                {t('createContract:result.duplicateContract', { count: acceptors.length })}
              </Button>
            </span>
            {secondaryButton}
          </div>
        </div>
      </div>
    );

    return (
      <div>
        {successRender}
        {steppers}
      </div>
    );
  }
}

export default withTranslation()(ResultStep);
